import React from "react";
import { Props } from "./types";

function EnglishIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 27 27">
      <defs>
        <clipPath id="clip-path-english-flag">
          <circle
            id="Ellipse_534"
            data-name="Ellipse 534"
            cx="13.5"
            cy="13.5"
            r="13.5"
            transform="translate(834 305)"
            fill="#fff"
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g
        transform="translate(-834 -305)"
        clipPath="url(#clip-path-english-flag)"
      >
        <g transform="translate(834 305)">
          <circle cx="13.5" cy="13.5" r="13.5" fill="#f0f0f0" />
          <g>
            <path
              id="Tracé_3275"
              data-name="Tracé 3275"
              d="M2.791,5.281a13.451,13.451,0,0,0-2.326,4.7H7.488Z"
              fill="#0052b4"
            />
            <path
              id="Tracé_3276"
              data-name="Tracé 3276"
              d="M26.535,9.978a13.452,13.452,0,0,0-2.326-4.7l-4.7,4.7Z"
              fill="#0052b4"
            />
            <path
              id="Tracé_3277"
              data-name="Tracé 3277"
              d="M.465,17.022a13.452,13.452,0,0,0,2.326,4.7l4.7-4.7Z"
              fill="#0052b4"
            />
            <path
              id="Tracé_3278"
              data-name="Tracé 3278"
              d="M21.719,2.791a13.452,13.452,0,0,0-4.7-2.326V7.488Z"
              fill="#0052b4"
            />
            <path
              id="Tracé_3279"
              data-name="Tracé 3279"
              d="M5.281,24.209a13.452,13.452,0,0,0,4.7,2.326V19.512Z"
              fill="#0052b4"
            />
            <path
              id="Tracé_3280"
              data-name="Tracé 3280"
              d="M9.978.465a13.452,13.452,0,0,0-4.7,2.326l4.7,4.7Z"
              fill="#0052b4"
            />
            <path
              id="Tracé_3281"
              data-name="Tracé 3281"
              d="M17.022,26.535a13.452,13.452,0,0,0,4.7-2.326l-4.7-4.7v7.023Z"
              fill="#0052b4"
            />
            <path
              id="Tracé_3282"
              data-name="Tracé 3282"
              d="M19.512,17.022l4.7,4.7a13.451,13.451,0,0,0,2.326-4.7Z"
              fill="#0052b4"
            />
          </g>
          <g id="Groupe_2702" data-name="Groupe 2702">
            <path
              id="Tracé_3283"
              data-name="Tracé 3283"
              d="M26.886,11.739H15.261V.114a13.624,13.624,0,0,0-3.522,0V11.739H.114a13.624,13.624,0,0,0,0,3.522H11.739V26.886a13.624,13.624,0,0,0,3.522,0V15.261H26.886a13.624,13.624,0,0,0,0-3.522Z"
              fill="#d80027"
            />
            <path
              id="Tracé_3284"
              data-name="Tracé 3284"
              d="M17.022,17.022h0l6.024,6.024q.416-.415.794-.867l-5.158-5.158h-1.66Z"
              fill="#d80027"
            />
            <path
              id="Tracé_3285"
              data-name="Tracé 3285"
              d="M9.978,17.022h0L3.954,23.046q.415.416.867.794l5.158-5.158v-1.66Z"
              fill="#d80027"
            />
            <path
              id="Tracé_3286"
              data-name="Tracé 3286"
              d="M9.978,9.978h0L3.954,3.954q-.416.415-.794.867L8.318,9.978h1.66Z"
              fill="#d80027"
            />
            <path
              id="Tracé_3287"
              data-name="Tracé 3287"
              d="M17.022,9.978h0l6.024-6.024q-.415-.416-.867-.793L17.022,8.318Z"
              fill="#d80027"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export { EnglishIcon };
